import ClientLoyaltyPage from './ClientLoyaltyPage';

export default ClientLoyaltyPage;
